import firebase from "../services/firebase";
import trackingService from "../services/tracking";

import * as sentry from "@sentry/browser";

class API {
  DEV_BASE_URL = "https://us-central1-autosplit-270a6.cloudfunctions.net/";
  DEV_STRIPE_PUBLIC_KEY = "pk_test_kjLn2dRheSNaVtOFqevVlekV00sdTRPqXs";

  PROD_BASE_URL = "https://us-central1-reconcile-prod.cloudfunctions.net/";
  PROD_STRIPE_PUBLIC_KEY = "pk_live_S9ZhcKUBKJ02DrSJRI0w6Ttj00qUa3hbkR";

  //only one of these
  PLAID_PUBLIC_KEY = "8f0ad8492c678dd1a5061416b12405";

  useLocal = false;

  getBaseUrl() {
    if (this.isProd()) {
      return this.PROD_BASE_URL;
    } else if (this.useLocal) {
      return this.getFirebaseLocalHost() + "/autosplit-270a6/us-central1/";
    } else return this.DEV_BASE_URL;
  }
  getFirebaseLocalHost() {
    return "http://localhost:5001";
  }
  isProd() {
    return process.env.REACT_APP_ENV === "production"; // || true; // force localhost to use prod services
  }
  getPlaidWebhookUrlForUid(uid) {
    return this.getBaseUrl() + `plaidWebhook?uid=${uid}`;
  }
  getPlaidPublicKey() {
    return this.PLAID_PUBLIC_KEY;
  }
  getStripePublicKey() {
    return this.isProd()
      ? this.PROD_STRIPE_PUBLIC_KEY
      : this.DEV_STRIPE_PUBLIC_KEY;
  }
  initDeleteSplitwiseExpense = ({
    expense,
    splitwiseToken,
    transaction_id,
  }) => {
    if (!splitwiseToken) {
      throw Error("no splitwiseToken Provided");
    }
    trackingService.logEvent("delete_splitwise_expense", {
      expense,
    });
    const deleteSplitwiseExpense = firebase
      .functions()
      .httpsCallable("deleteSplitwiseExpense");
    return deleteSplitwiseExpense({
      splitwiseToken, // secrisk?
      expense,
      transaction_id,
    })
      .then((result) => console.log("success result: ", result))
      .catch((error) => console.log("error: ", error));
  };

  initSplitwiseExpense = ({ transaction, options, splitwiseToken }) => {
    if (!splitwiseToken) {
      throw Error("no splitwiseToken Provided");
    }
    trackingService.logEvent("create_splitwise_expense", {
      transaction,
      options,
    });
    const initSplitwiseExpense = firebase
      .functions()
      .httpsCallable("initSplitwiseExpense");
    return initSplitwiseExpense({
      splitwiseToken, // secrisk?
      transaction,
      options,
    })
      .then((result) => console.log("success result: ", result))
      .catch((error) => console.log("error: ", error));
  };
  deleteRecurringRule = (recurRule) => {
    const deleteRecurRule = firebase
      .functions()
      .httpsCallable("deleteRecurRule");
    return deleteRecurRule({ recurRule })
      .then((result) => console.log("success result: ", result))
      .catch((error) => console.log("error: ", error));
  };
  createAndChargeCustomer = async (data) => {
    const createAndChargeCustomer = firebase
      .functions()
      .httpsCallable("stripeCreateAndChargeCustomer");
    const response = await createAndChargeCustomer(data);
    return response.data;
  };
  cancelSubscription = async (data) => {
    const stripeCancelSubscription = firebase
      .functions()
      .httpsCallable("stripeCancelSubscription");
    const response = await stripeCancelSubscription(data);
    return response.data;
  };
  // had to update security rules because of this function
  markSentToVenmo = async (uid, transaction, remove = false) => {
    const doc = firebase
      .firestore()
      .doc(`users/${uid}/transactions/${transaction.transaction_id}`);
    doc.set(
      {
        reconcileRecord: {
          sentToVenmo: remove ? null : new Date(),
        },
      },
      { merge: true }
    );
  };
  getStripePortalLink = async (subscriptionId) => {
    try {
      const stripeGetPortalUrl = firebase
        .functions()
        .httpsCallable("stripeGetPortalUrl");
      const { data } = await stripeGetPortalUrl({
        subscriptionId,
      });
      return data;
    } catch (error) {
      sentry.captureException(error);
      return null;
    }
  };
  exchangePlaidToken = async (public_token, metadata) => {
    try {
      trackingService.logEvent("exchange_plaid_token", { metadata });
      const plaidExchangeToken = firebase
        .functions()
        .httpsCallable("plaidExchangeToken");
      const result = await plaidExchangeToken({
        public_token,
        metadata,
      });
      return result;
    } catch (error) {
      sentry.captureException(error);
      return null;
    }
  };
  removePlaidItem = async (plaid_item) => {
    try {
      trackingService.logEvent("remove_plaid_item", { plaid_item });
      const plaidRemoveItem = firebase
        .functions()
        .httpsCallable("plaidRemoveItem");
      const result = await plaidRemoveItem(plaid_item);
      return result;
    } catch (error) {
      sentry.captureException(error);
      return null;
    }
  };
}

export default new API();
